import React, {useState} from 'react';
import {View, TouchableOpacity, Platform} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

import Text from '../../elements/Text';
import NoteCard from '../NoteCard';
import AddNewNoteDrawer from '../AddNewNoteDrawer';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {BUTTON_TYPES} from '../../../utils/Constants';
import ViewNoteModal from '../ViewNoteModal';
import {DLog} from '../../../utils/HelperMethods';
import {useOutletContext} from '../../../utils/mockedWebLibs/react-router-dom';
import {tID} from '../../../utils/TestIdHelper';
import {AddIcon} from '../../../utils/SvgIcons';

const Notes = ({
  navigation,
  notes,
  onChangeNotes,
  hideAddButton = false,
  listView = false,
  showDateTime = false,
  allValues = false,
  title,
  getData,
}) => {
  //adding a variable listView to denote that the
  //notes are being displayed in a list view in View Blood Sugar History
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [showAddNote, setShowAddNote] = useState(false);
  const [showNote, setShowNote] = useState(false);
  // const [readingNotes, setReadingNotes] = useState(notes || []);
  const [selectedNote, setSelectedNote] = useState({});

  const setOpenManualEntry = useOutletContext()?.setOpenManualEntry;
  const insets = useSafeAreaInsets();

  const onPressAddNote = () => {
    setShowAddNote(true);
  };

  const onPressCloseAddNote = () => {
    setSelectedNote({});
    setShowAddNote(false);
  };

  const onPressSaveNote = note => {
    DLog('onPressSaveNote', note);
    const n = [...notes];
    if (note.createAt) {
      const idx = notes.indexOf(selectedNote);
      n[idx] = note;
    } else {
      n.push({
        title: note.title,
        noteText: note.noteText,
        createAt: note.readingDateTime,
      });
    }
    setSelectedNote({});
    // setReadingNotes(notes);
    //send all nots if not listview otherwise send only the last updated note
    onChangeNotes(listView ? n.pop() : n);
    setShowAddNote(false);
  };

  const onPressEditNote = note => {
    if (allValues) {
      // DLog('onPressEditNote', note.extraData, getData);
      if (Platform.OS === 'web') {
        setOpenManualEntry({
          onGoBack: getData,
          extraData: note.extraData,
        });
      } else {
        navigation.navigate('AddGlucoseLevel', {
          onGoBack: getData,
          extraData: note.extraData,
        });
      }
    } else {
      setSelectedNote(note);
      setShowAddNote(true);
      setShowNote(false);
    }
  };

  const onPressShowNote = note => {
    if (allValues) {
      DLog('onPressShowNote', note);
    } else {
      setShowNote(true);
      setSelectedNote(note);
    }
  };

  return (
    <>
      <View style={[styles.container, {paddingBottom: (insets.bottom || 0) + 16}]}>
        {allValues ? (
          <Text testID={tID('Notes-Text-Title')} color={colors.textHeading}>
            {title}
          </Text>
        ) : (
          <>
            <Text
              testID={tID('Notes-Text-Title')}
              variation="Subtitle1SemiBold"
              color={colors.textHeading}>
              {listView ? 'My Notes' : 'Related Notes'}
            </Text>
            <Text
              testID={tID('Notes-Text-SubTitle')}
              variation="Subtitle2Regular"
              color={colors.textTertiary}
              topMargin={5}>
              {listView
                ? 'Add notes for days, weeks or months.'
                : 'Add notes to detail specifics of your day.'}
            </Text>
          </>
        )}

        <View
          style={
            Platform.OS === 'web' && allValues
              ? styles.allValuesWebStyle
              : undefined
          }>
          {notes.map((note, idx) => (
            <NoteCard
              key={idx}
              style={styles.marginTop16}
              note={note}
              onPressNote={() => onPressShowNote(note)}
              onPressEdit={() => onPressEditNote(note)}
              listView={listView}
              index={idx + 1}
              showDateTime={showDateTime}
            />
          ))}
        </View>
        {!hideAddButton && (
          <TouchableOpacity
            testID={tID('Notes-TouchableOpacity-AddNewNote')}
            style={styles.newNoteButton}
            onPress={onPressAddNote}>
            <Text variation="Body1SemiBold" color={colors.link}>
              Add New Note
            </Text>
            <AddIcon />
          </TouchableOpacity>
        )}
      </View>
      <AddNewNoteDrawer
        visible={showAddNote}
        note={selectedNote}
        showDateTime={showDateTime}
        onClose={onPressCloseAddNote}
        buttons={[
          {
            title: 'Cancel',
            buttonType: BUTTON_TYPES.Bordered,
            onPress: onPressCloseAddNote,
          },
          {
            title: 'Save',
            buttonType: BUTTON_TYPES.Filled,
            onPress: onPressSaveNote,
          },
        ]}
      />
      <ViewNoteModal
        onEdit={() => {
          onPressEditNote(selectedNote);
        }}
        visible={showNote}
        note={selectedNote}
        onRequestClose={() => {
          setSelectedNote({});
          setShowNote(false);
        }}
        listView={listView}
      />
    </>
  );
};

export default Notes;
